import { FC } from "react";
import { useTranslation } from "react-i18next";

import { DownloadsAppButtons } from "../widgets";

export const PassengerAlreadyRegisteredError: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <h1 className="landing-title">{t("landing.duplicateDetailsError")}</h1>
      <div className="landing-sub-title">{t("landing.downloadAppPrompt")}</div>
      <div className="divider-bar" aria-hidden="true" />
      <DownloadsAppButtons />
    </>
  );
};
